import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';
import Slider from 'react-slick';

import FeaturedArticleSlide from '../FeaturedArticleSlide';

export default class FeaturedArticleSlider extends Component {
  render() {
    const config = Theme.featured_article_slider.config;

    if(!this.props.articles) {
      return false;
    }

    return (
      <div className={css(styles.container)}>
        <Slider {...config}>
          {
            this.props.articles && this.props.articles.map((post) => (
              <div className={css(styles.cover)}><FeaturedArticleSlide {...post} /></div>
            ))
          }
        </Slider>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: Theme.featured_article_slider.width,
    height: Theme.featured_article_slider.height,
    [Theme.mobile_query]: {
      height: window.innerHeight - (Theme.navigation.height),
    },
  },
  cover: {
    position: 'relative',
    width: Theme.featured_article_slider.width,
    height: Theme.featured_article_slider.height,
    [Theme.mobile_query]: {
      height: window.innerHeight - (Theme.navigation.height),
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/FeaturedArticleSlider/index.js